module.exports = __webpack_public_path__ + "media/images/icon__info--white-f53dfc549aa44188edd24e466ec3fc70.png";